import React from 'react';
import { Control } from 'react-hook-form';
import { CreateArrayOptions } from '@/constants/constant';
import LessonDetailsSection from './LessonDetailsSection';
import TimingSection from './TimingSection';
import AdditionalSection from './AdditionalSection';

interface FormSectionsProps {
  control: Control<any>;
  isPaidInitial: boolean;
  instructors: Array<{ value: number; label: string }>;
  serviceOptions: Array<{ value: number; label: string }>;
  hotels: Array<{
    value: string | number;
    label: string;
    google_map_link?: string;
  }>;
  cars: Array<{ value: string | number; label: string }>;
  mountains: Array<{ value: string | number; label: string }>;
  agents: Array<{ value: string | number; label: string }>;
  timeOptions: Array<{ value: string; label: string }>;
  pickupTimeOptions: Array<{ value: string; label: string }>;
  commentsLength: number;
  CreateArrayOptions: typeof CreateArrayOptions;
  lessonsEntry?: string;
}

const FormSections: React.FC<FormSectionsProps> = ({
  control,
  isPaidInitial,
  instructors,
  serviceOptions,
  hotels,
  cars,
  mountains,
  agents,
  timeOptions,
  pickupTimeOptions,
  commentsLength,
  CreateArrayOptions,
  lessonsEntry
}) => {
  return (
    <div className=''>
      {/* Lesson details */}
      <LessonDetailsSection
        control={control}
        isPaidInitial={isPaidInitial}
        instructors={instructors}
        stringOptions={CreateArrayOptions(20, 'Select String')}
        serviceOptions={serviceOptions}
        timeOptions={timeOptions}
      />

      {/* Timing */}
      <TimingSection
        control={control}
        isPaidInitial={isPaidInitial}
        pickupTimeOptions={pickupTimeOptions}
        hotels={hotels}
        cars={cars}
        mountains={mountains}
        agents={agents}
        lessonsEntry={lessonsEntry}
      />

      {/* Additional */}
      <AdditionalSection
        control={control}
        isPaidInitial={isPaidInitial}
        commentsLength={commentsLength}
      />
    </div>
  );
};

export default FormSections;
